<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Vehicle Actual Route">
        <!-- <v-card-actions>
          <router-link :to="{ name: 'assignBusRouteStudent', params: {} }" title="Assign Bus Route To Student">
            <v-btn absolute right top elevation="1" color="primary">
              <v-icon left>mdi-plus</v-icon>
              Assign Bus Route To Student
            </v-btn>
          </router-link>

        </v-card-actions> -->
        <v-card flat class="px-2">
          <form @submit.prevent="Save">
            <!-- <v-row>
             <v-col cols="12" md="6" lg="5">
                <label class="font-weight-medium body-2">Select Vehicle Route <span class="error--text">*</span></label>
                <v-autocomplete class="my-0 py-1" prepend-icon="mdi-account"
                :items="vehicleRouteDetails"
                key="id"
                item-text="routeName"
                item-value="id"
                v-model="VehicleRouteId"
                single-line required
                placeholder="--Select--"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">Filter Action</label>

                <div class="inside">
                  <v-btn class="mr-4" color="success" elevation="1" type="submit">
                    <v-icon left> mdi-text-box-check-outline </v-icon>
                    Apply</v-btn
                  >
                </div>
              </v-col>
            </v-row> -->
          </form>
        </v-card>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="vehicleRouteAssign"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="dropStudent(item.busStopID,item.studentID,item.vehicleRouteStop.StopNumber)">
                  Drop Student
                </v-btn>
                <v-btn x-small class="px-2 ml-1 ma-1" color="primary" outlined @click.prevent="toggledropStudentModal(item.studentID)">
                  Drop Student At Other Location
                </v-btn>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <div class="modal" :class="{ 'is-active': enabletoggledropStudentModal }">
        <form @submit.prevent="saveData()">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Drop Student</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggledropStudentModal, clearEditBusRoute()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row style="width:1000px;">
                <v-col cols="12" md="6">
                  <v-text-field  label="Route Name" required v-model.trim="routeName" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field   label="City" required v-model.trim="city" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field   label="State" required v-model.trim="state" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field  label="Pincode" required v-model.trim="pincode" counter="6" maxlength="6"
                  oninput="javascript: if (this.value.length > this.maxLength ) this.value = this.value.slice(0, this.maxLength);"
                   type="number"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Lattitude" v-model.trim="lattitude" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Longitude" v-model.trim="longitude" type="text"> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Reamrk" required v-model.trim="reamrk" type="text"> </v-text-field>
                </v-col>
                 <v-col cols="12" md="6">
                  <v-text-field  label="Stop Number" required v-model.trim="stopNumber" type="number"> </v-text-field>
                </v-col>
              <v-col style="right:300px;" cols="12" md="6">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
    </div>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
// import Utils from '@/utils'
// import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'VehicleActualRoute',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: '',
      vehicleRouteDetails: [],
      VehicleRouteId: '',
      routeName: '',
      city: '',
      pincode: null,
      state: '',
      reamrk: '',
      noOfStudentDrop: null,
      lattitude: '',
      longitude: '',
      stopNumber: null,
      studID: '',
      enabletoggledropStudentModal: false,
      vehicleRouteAssign: [],
      total: '',
      headers: [
        { text: 'Vehicle Route', value: 'vehicleBusRoute.routeName', sortable: true },
        { text: 'Vehicle Route Type', value: 'vehicleBusRoute.isPickUp', sortable: true },
        { text: 'Vehicle Route Stop', value: 'vehicleRouteStop.pickUpStop', sortable: true },
        { text: 'Stop Number', value: 'vehicleRouteStop.StopNumber', sortable: true },
        { text: 'Student Name', value: 'studentAdmission.studentEnrollment.studentName', sortable: true },
        { text: 'Pick up Time', value: 'vehicleRouteStop.pickupTime', sortable: true },
        { text: 'Nearest Land Mark', value: 'vehicleRouteStop.nearestLandMark', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      docsheaders: [
        { text: 'Vehicle Challan Documents', value: 'Vehicle_Documents', sortable: true }
      ]
    }
  },
  async created () {
    await this.getVehicleList()
  },
  methods: {
    dropStudent (busStopID, studentID, StopNumber) {
      this.$buefy.dialog.confirm({
        title: 'Drop Student',
        message: '"Do you want to Drop Student"?',
        confirmText: 'Drop Student',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.ShowDocuments(busStopID, studentID, StopNumber)
        }
      })
    },
    ShowDocuments: async function (busStopID, studentID, StopNumber) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('busStopID', busStopID)
        formData.append('reamrk', 'Student is Dropped')
        formData.append('noOfStudentDrop', 1)
        formData.append('stopNumber', StopNumber)
        formData.append('studentID', studentID)
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.post(`${constants.API_URL}/api/transport/vehicleActualRoute/vehicleActualRoute`, formData)
        this.loader = false
        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Student Drop successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    toggledropStudentModal: function (studentID) {
      this.studID = studentID
      this.enabletoggledropStudentModal = !this.enabletoggledropStudentModal
    },
    getVehicleList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicleActualRoute/vehicleActualRoute`)
        this.vehicleRouteDetails = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    Save: async function () {
      this.vehicleRouteAssign = []
      this.total = ''
      try {
        let getParam = {}
        getParam.busRouteID = this.VehicleRouteId
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicleRouteAssignStudents/vehicleRouteAssignStudents`, {
          params: getParam
        })
        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleRouteAssign = data
          this.vehicleRouteAssign = _.sortBy(this.vehicleRouteAssign, 'vehicleRouteStop.StopNumber')
          this.vehicleRouteAssign.forEach(element => {
            element.vehicleBusRoute.isPickUp = element.vehicleBusRoute.isPickUp === true ? 'Pick Up' : 'Drop'
          })
          this.total = this.vehicleRouteAssign.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    saveData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let formData = new FormData()
        formData.append('routeName', this.routeName)
        formData.append('city', this.city)
        formData.append('pincode', this.pincode)
        formData.append('state', this.state)
        formData.append('reamrk', this.reamrk)
        formData.append('noOfStudentDrop', 1)
        formData.append('lattitude', this.lattitude)
        formData.append('longitude', this.longitude)
        formData.append('stopNumber', this.stopNumber)
        formData.append('studentID', this.studID)
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.post(`${constants.API_URL}/api/transport/vehicleActualRoute/vehicleActualRoute`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.clearEditBusRoute()
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Student Drop successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearEditBusRoute: function () {
      this.routeName = ''
      this.city = ''
      this.state = ''
      this.reamrk = ''
      this.lattitude = ''
      this.longitude = ''
      this.pincode = null
      this.stopNumber = null
      this.enabletoggledropStudentModal = !this.enabletoggledropStudentModal
    }
  }
}
</script>
